import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import * as React from 'react';
import LogoInvertedSvg from './logo-inverted.svg';
import { NavLink } from 'react-router-dom';

const styles = createStyles({
  container: {
    flex: 1,
  },
  logo: {
    height: 52,
  },
});

interface IProps
  extends WithStyles<typeof styles> {}

class CompanyLogo extends React.Component<IProps> {
  public render() {
    const { classes } = this.props;

    return (
      <span className={classes.container}>
        <NavLink to="/">
          <img src={LogoInvertedSvg} className={classes.logo} />
        </NavLink>
      </span>
    );
  }
}

export default withStyles(styles)(CompanyLogo);



// WEBPACK FOOTER //
// ./src/modules/shared/components/CompanyLogo.tsx